import { z } from 'zod';

import type { TFunction } from 'i18next';

import { stripHtml } from '@/helpers';

export function createPromotionFormSchema(t: TFunction, isEditMode = false) {
  return z.object({
    name: z
      .string({ message: t('validation_required') })
      .min(1, { message: t('validation_required') })
      .trim(),
    description: z.string().refine((val) => stripHtml(val).trim().length > 0, {
      message: t('validation_required'),
    }),
    image: isEditMode
      ? z.union([z.instanceof(File), z.string()]).optional()
      : z.instanceof(File, { message: t('validation_required') }),
    active: z.boolean(),
  });
}

export type PromotionFormValues = z.infer<
  ReturnType<typeof createPromotionFormSchema>
>;
